import React from "react";
import widgetCss from "./widget-raw.css?raw";
import { WidgetWithStore } from "./widget-store";
import "./widget-trigger"; 
export function initializeWebComponent() {
  if (typeof window === "undefined") return;

  window.React = React;

  import("@r2wc/react-to-web-component")
    .then((r2wcModule) => {
      const r2wc = r2wcModule.default;

      const WebWidget = r2wc(WidgetWithStore, {
        props: { position: "string", agentid: "string" },
        shadow: "open",
      });

      class OutsellaWidgetElement extends WebWidget {
        async connectedCallback() {
          try {
            await super.connectedCallback?.();

            if (this.shadowRoot) {
              // Create a style element for the widget CSS
              const style = document.createElement("style");
              style.textContent = widgetCss;
              this.shadowRoot.appendChild(style);

              // Create a style element for CSS variables from the parent document
              const parentStyle = document.createElement("style");
              parentStyle.textContent = `
                :host {
                  /* Copy CSS variables from the parent document */
                  --destructive: var(--destructive, #ef4444);
                  --destructive-foreground: var(--destructive-foreground, #ffffff);
                  --primary: var(--primary, #0051ff);
                  --primary-foreground: var(--primary-foreground, #ffffff);
                  --secondary: var(--secondary, #f3f4f6);
                  --secondary-foreground: var(--secondary-foreground, #000000);
                  --accent: var(--accent, #f3f4f6);
                  --accent-foreground: var(--accent-foreground, #000000);
                  --muted: var(--muted, #f3f4f6);
                  --muted-foreground: var(--muted-foreground, #6b7280);
                  --card: var(--card, #ffffff);
                  --card-foreground: var(--card-foreground, #000000);
                  --popover: var(--popover, #ffffff);
                  --popover-foreground: var(--popover-foreground, #000000);
                  --border: var(--border, #e5e7eb);
                  --input: var(--input, #e5e7eb);
                  --ring: var(--ring, #0051ff);
                  --radius: var(--radius, 0.5rem);
                  --background: var(--background, #ffffff);
                  --foreground: var(--foreground, #000000);
                }
              `;
              this.shadowRoot.appendChild(parentStyle);

              console.log("Styles and CSS variables injected into shadow DOM");
            } else {
              console.error("No shadow root available to inject styles");
            }
          } catch (error) {
            console.warn("Error in parent connectedCallback:", error);
          }
        }
      }

      if (!customElements.get("outsella-widget")) {
        customElements.define(
          "outsella-widget",
          OutsellaWidgetElement as unknown as CustomElementConstructor
        );
        console.log("Outsella widget custom element registered successfully");

        document.addEventListener("DOMContentLoaded", () => {
          const scriptTag = document.querySelector(
            'script[src*="main.umd.js"]'
          );
          if (scriptTag) {
            const position = scriptTag.getAttribute("data-position") || "right";
            const agentId = scriptTag.getAttribute("data-agentid") || "";
            const widget = document.createElement("outsella-widget");
            widget.setAttribute("position", position);
            widget.setAttribute("agentid", agentId);
            document.body.appendChild(widget);
          } else {
            console.error(
              "No script tag found with src containing 'main.umd.js'"
            );
          }
        });
      }
    })
    .catch((err) => {
      console.error("Error loading r2wc:", err);
    });
}

initializeWebComponent();
